import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ActivityTimeDiffDisplay } from './ActivityTimeDiffDisplay';
import { getTimeDifference } from '../../utils';
import { useNow } from '../../api/resources/useNow';

interface ActivityBarProps {
  isCameraOnline: boolean;
  captureStartAt: string;
}

export default function ActivityBar({ isCameraOnline, captureStartAt }: ActivityBarProps) {
  const { t } = useTranslation();
  const now = useNow();

  const activityTimeDiff = getTimeDifference(captureStartAt ? new Date(captureStartAt) : undefined, now);

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        display: 'flex',
        borderRadius: '10px',
        padding: 2,
        gap: 4,
        height: 'max-content',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <StatusDot color={isCameraOnline ? 'green' : 'red'} />
        <Typography variant='h6' sx={{ fontWeight: 600 }}>
          {t('activity.camera')}:
        </Typography>
        <Typography variant='h6'>{t(isCameraOnline ? 'activity.online' : 'activity.offline')}</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant='h6' sx={{ fontWeight: 600 }}>
          {t('activity.latestActivity')}:
        </Typography>
        <Typography variant='h6'>
          <ActivityTimeDiffDisplay timeDiff={activityTimeDiff} />
        </Typography>
      </Box>
    </Box>
  );
}

function StatusDot({ color }: { color: string }) {
  return <Box sx={{ width: '15px', height: '15px', borderRadius: '50%', backgroundColor: color }}></Box>;
}
